import React, { useEffect, useState } from 'react';
import { getAbsences } from '../services/timesheetService';

const AbsenceReport = () => {
  const today = new Date().toISOString().split('T')[0];
  const monthAgo = new Date();
  monthAgo.setDate(monthAgo.getDate() - 30);
  const defaultStart = monthAgo.toISOString().split('T')[0];

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(today);
  const [absences, setAbsences] = useState([]);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      setError('');
      const res = await getAbsences(startDate, endDate);
      setAbsences(res.data);
    } catch (e) {
      setError('Erreur lors du chargement des absences');
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card">
      <h3>Absences non justifiées</h3>
      <div className="form-row">
        <div className="form-group">
          <label>Début</label>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Fin</label>
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>
        <button className="btn btn-secondary" onClick={load}>Filtrer</button>
      </div>
      {error && <div className="error-banner">{error}</div>}
      {!absences.length && !error && <div>Aucune absence</div>}
      {absences.length > 0 && (
        <table className="employee-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Employé</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {absences.map((a) => (
              <tr key={a.id}>
                <td>{a.formattedDate || a.date}</td>
                <td>{a.employeeName}</td>
                <td>{a.statusLabel || a.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AbsenceReport;

